export default map => Array.from(map)[map.size - 1];
